import { render, staticRenderFns } from "./AppBadge.vue?vue&type=template&id=4c47ed46"
import script from "./AppBadge.vue?vue&type=script&lang=ts"
export * from "./AppBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports